import React, { FC } from "react";
import "./WelcomePage.scss";
import TwoSidePage from "../twoSidePage/TwoSidePage";
import ButtonType from "../../../common/button/ButtonTypes";
import Button from "../../../common/button/Button";
import { usePersonalPage } from "../../index";
import ValueInput from "./ValueInput";
import LanguageSelector from "./LanguageSelector";
import { useTranslation } from "react-i18next";

const WelcomePage: FC = () => {
  const { handleBlur, state, updateProfileAndFetchUserInputIds } =
    usePersonalPage(false);

  const { t, ready } = useTranslation("welcomePage");

  return (
    <TwoSidePage>
      <div className="welcome-page__container">
        <h1>{ready ? t("title") : "Welcome to Klassifai"}</h1>
        <div className="welcome-page__form">
          <p>
            {ready
              ? t("description")
              : "To personalize your experience, we'd like to learn a little more about you."}
          </p>
          <ValueInput
            value={state.firstName}
            name="firstName"
            label={ready ? t("firstNameLabel") : "First Name"}
            handleBlur={handleBlur}
          />
          <ValueInput
            value={state.lastName}
            name="lastName"
            label={ready ? t("lastNameLabel") : "Last Name"}
            handleBlur={handleBlur}
          />
          <LanguageSelector label={ready ? t("languageLabel") : "Language"} />
          <Button
            className="sign-in-button"
            handleClick={updateProfileAndFetchUserInputIds}
            buttonType={ButtonType.Primary}
            text={ready ? t("saveButton") : "Confirm"}
            icon={<i className="bi bi-check2" />}
            disabled={!state.firstName.trim() || !state.lastName.trim()}
          />
        </div>
      </div>
    </TwoSidePage>
  );
};

export default WelcomePage;
